import React from 'react';
import { useNavigate } from 'react-router-dom';
import Sym from '../components/Sym';
import { PLANS, formatMXN } from '../data/plans';

/**
 * Teaser de Precios del home: los 3 primeros tiers como preview + link a /pricing
 * (donde vive la calculadora y los 7 planes). Números desde el módulo compartido
 * data/plans.js → nunca hay drift con billing. El "Más elegido" ya lo marca el
 * propio módulo (hoy tier-200, decisión de negocio).
 */
const NOTES = {
  'tier-20': 'Incluye 15 días de prueba',
  'tier-50': 'Para equipos que crecen',
  'tier-200': 'El favorito de las medianas',
};

const PricingTeaser2 = () => {
  const navigate = useNavigate();
  const preview = PLANS.slice(0, 3);
  return (
    <section style={{ maxWidth: 1200, margin: '0 auto', padding: '48px clamp(20px,5vw,40px)' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: 36 }}>
        <div style={{ maxWidth: 560 }}>
          <span style={{ font: "700 .8rem 'IBM Plex Mono'", letterSpacing: '.14em', textTransform: 'uppercase', color: '#6FA0FF' }}>Precios</span>
          <h2 style={{ font: "600 clamp(2rem,4.5vw,3.1rem)/1.05 'Source Serif 4'", letterSpacing: '-.02em', color: 'var(--heading)', margin: '12px 0 0', textWrap: 'balance' }}>
            Un precio fijo, <span style={{ fontStyle: 'italic', color: '#6FA0FF' }}>según tu tamaño</span>
          </h2>
          <p style={{ font: "400 1.05rem/1.55 'Hanken Grotesk'", color: 'var(--muted)', margin: '12px 0 0' }}>Sin costo por colaborador. Todo con IVA incluido, en pesos.</p>
        </div>
        <a
          onClick={() => navigate('/pricing')}
          style={{ display: 'inline-flex', alignItems: 'center', gap: 8, font: "700 1rem 'Hanken Grotesk'", color: '#6FA0FF', cursor: 'pointer' }}
        >
          Ver todos los planes<Sym name="arrow_forward" size={20} color="#6FA0FF" />
        </a>
      </div>
      <div className="ls2-grid3">
        {preview.map((p) => (
          <div key={p.slug} style={{ position: 'relative', background: 'var(--surface)', border: `1px solid ${p.popular ? 'transparent' : 'var(--border)'}`, borderRadius: 22, padding: 30 }}>
            {p.popular && (
              <>
                <span style={{ position: 'absolute', inset: -1.5, border: '2px solid #2F6BFF', borderRadius: 22, pointerEvents: 'none', boxShadow: '0 0 34px -6px rgba(47,107,255,.6)' }} />
                <span style={{ position: 'absolute', top: -13, left: 30, background: '#2F6BFF', color: '#fff', font: "700 .74rem 'IBM Plex Mono'", letterSpacing: '.04em', padding: '5px 12px', borderRadius: 999 }}>Más elegido</span>
              </>
            )}
            <div style={{ font: "700 .74rem 'IBM Plex Mono'", letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--label)' }}>Colaboradores</div>
            <div style={{ font: "600 1.7rem 'Source Serif 4'", color: 'var(--heading)', margin: '4px 0 18px' }}>{p.rango}</div>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
              <span style={{ font: "600 2.7rem 'Source Serif 4'", color: 'var(--heading)' }}>${formatMXN(p.price)}</span>
              <span style={{ font: "500 1rem 'Hanken Grotesk'", color: 'var(--muted-2)' }}>/mes</span>
            </div>
            <div style={{ font: "500 .85rem 'Hanken Grotesk'", color: 'var(--faint)', marginTop: 6 }}>{NOTES[p.slug] || ''}</div>
            <button
              type="button"
              onClick={() => navigate('/register')}
              style={p.popular
                ? { width: '100%', marginTop: 22, padding: 14, font: "700 1rem 'IBM Plex Mono'", color: '#0E1A30', background: '#fff', border: 'none', borderRadius: 12, cursor: 'pointer', transition: 'transform .18s' }
                : { width: '100%', marginTop: 22, padding: 14, font: "700 1rem 'IBM Plex Mono'", color: 'var(--heading)', background: 'transparent', border: '1.5px solid var(--border-strong)', borderRadius: 12, cursor: 'pointer', transition: 'border-color .18s' }}
              onMouseEnter={(e) => { if (p.popular) e.currentTarget.style.transform = 'translateY(-2px)'; else e.currentTarget.style.borderColor = '#6FA0FF'; }}
              onMouseLeave={(e) => { if (p.popular) e.currentTarget.style.transform = 'none'; else e.currentTarget.style.borderColor = 'var(--border-strong)'; }}
            >
              {p.popular ? 'Comenzar ahora' : 'Ver plan'}
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PricingTeaser2;
